module.exports = __webpack_public_path__ + "static/media/medicaments.08ec0074.svg";